export default {
  functionKey: "REPT",
  title: "REPT",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Count", name: "Nombre de répétitions" }],
  expectedArguments: [
    { name: "Nombre de répétitions", argumentKey: "Count", single: true, initialValue: "2" }
  ],
  description: "Répète un texte N fois. (Ex: REPT('ab', 3) -> 'ababab')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const count = args[0] ?? "1";
    const code = `${destination} = ${origin}.repeat(${count});`;
    return { displayCode: code, safeCode: code };
  }
}
